/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProgramNovaInsights_viewer = {
    readonly id: string;
    readonly program: {
        readonly id: string;
        readonly name: string | null;
        readonly color: string | null;
        readonly projectHealthRollup: {
            readonly suggestedStatusDisagreesRag: string | null;
            readonly suggestedStatusDisagreesMessage: string | null;
            readonly predictedOverrunRag: string | null;
            readonly predictedOverrunMessage: string | null;
            readonly budgetOverrunRag: string | null;
            readonly budgetOverrunMessage: string | null;
            readonly projectHealthResponses: ReadonlyArray<{
                readonly projectId: number | null;
                readonly predictedEndDateRAGStatus: string | null;
                readonly predictedEndDateInfo: string | null;
                readonly predictedEndDateError: string | null;
                readonly budgetInsightRag: string | null;
                readonly budgetInsightInfoShort: string | null;
                readonly budgetInsightError: string | null;
                readonly suggestedStatusRag: string | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": "ProgramNovaInsights_viewer";
};
export type ProgramNovaInsights_viewer$data = ProgramNovaInsights_viewer;
export type ProgramNovaInsights_viewer$key = {
    readonly " $data"?: ProgramNovaInsights_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProgramNovaInsights_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "prefix",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProgramNovaInsights_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "prefix",
          "variableName": "prefix"
        }
      ],
      "concreteType": "ProgramType",
      "kind": "LinkedField",
      "name": "program",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectHealthRollup",
          "kind": "LinkedField",
          "name": "projectHealthRollup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "suggestedStatusDisagreesRag",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "suggestedStatusDisagreesMessage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "predictedOverrunRag",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "predictedOverrunMessage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "budgetOverrunRag",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "budgetOverrunMessage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MultiProjectHealth",
              "kind": "LinkedField",
              "name": "projectHealthResponses",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "predictedEndDateRAGStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "predictedEndDateInfo",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "predictedEndDateError",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "budgetInsightRag",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "budgetInsightInfoShort",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "budgetInsightError",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "suggestedStatusRag",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '7170c6f2b66254d6ee308669707110ba';
export default node;
